import contractService from "../../services/contracts";


const contract = {
  namespaced: true,
  state: {
    contractList: [],
    tokenList: []
  },
  actions: {
    getContractList(store) {
      return new Promise((resolve, reject) => {
        contractService.getContractList().then(res => {
            store.commit('SET_CONTRACT_LIST', res);
            resolve(res);
        }).catch(err => {
          reject(err);
        });
      })
    },
    getTokenList(store) {
      return new Promise((resolve, reject) => {
        contractService.getTokenList().then(res => {
            store.commit('SET_TOKEN_LIST', res);
            resolve(res);
        }).catch(err => {
          reject(err);
        });
      })
    },
  },
  getters: {
    contractList: (state) => state.contractList,
    tokenList: (state) => state.tokenList
  },
  mutations: {
    SET_CONTRACT_LIST: (state, contracts) => {
      state.contractList = contracts;
    },
    SET_TOKEN_LIST: (state, tokenList) => {
      state.tokenList = tokenList;
    },
  }

};

export default contract;